import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { deploymentStatuses } from '@/components/newDevice/deploymentStatuses.js';

export const StatusWithIcon = ({ statusId }) => {
    const translate = useTranslate();
    const status = deploymentStatuses(translate).find(s => s.id === statusId);

    if (!status) return null;

    return (
        <Box display='flex' alignItems='center' className='status'>
            <Box component='img' src={status.icon} alt={status.name} sx={{ marginRight: '12px', width: 20, height: 20 }} />
            <Typography sx={{ whiteSpace: 'nowrap' }}>{status.name}</Typography>
        </Box>
    );
};

StatusWithIcon.propTypes = {
    statusId: PropTypes.string,
};
